import { usePage } from "@inertiajs/react";
import InvitationFormPage, { DefaultInvitationLayout } from "@/pages/invitations/invitation-form-page";
import { manage_invitations_path, manage_users_path } from "@/routes";

function NewManageInvitation({ invitation = {} }) {
  return (
    <InvitationFormPage
      invitation={invitation}
      title="Invitér bruger"
      eyebrow="Administration"
      description="Vælg organisation, e-mail og rolle for den nye invitation."
      backHref={manage_users_path()}
      submitPath={manage_invitations_path()}
      breadcrumbs={[
        { label: "Administration", href: manage_users_path() },
        { label: "Alle brugere", href: manage_users_path() },
        { label: "Invitér" }
      ]}
      organizationLocked={false}
    />
  );
}

NewManageInvitation.layout = (page) => (
  <DefaultInvitationLayout
    page={page}
    title="Invitér bruger"
    backHref={manage_users_path()}
    breadcrumbs={[
      { label: "Administration", href: manage_users_path() },
      { label: "Alle brugere", href: manage_users_path() },
      { label: "Invitér" }
    ]}
  />
);

export default NewManageInvitation;
